import React, { useState } from "react";
import { Button } from "../../components/styled-components/button";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router";

export const AcceptInvitation = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const params = useParams();
  console.log("params", location.state.from.search);
  let param = location.state.from.search.slice(12);
  console.log("slice", param);
  localStorage.setItem("invite", param);
  const history = useHistory();
  console.log("");

  const handleAccept = () => {
    console.log("Accepted");
    try {
      (async () => {
        setLoading(true);
        let responseData = await DEATH_API.acceptInvitation(param);
        console.log("responseData", responseData);
        if (responseData) {
          // route from here to login
          history.push("/delgateAccess");
        }
        setLoading(false);
      })();
    } catch (error) {
      setLoading(false);
      console.log("error");
    }
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "4rem",
          alignItems: "center",
        }}
      >
        <h1>Invitation Form</h1>
        <Button
          style={{ marginTop: "1rem",background:"#2A3DA3" }}
          onClick={() => {
            handleAccept();
          }}
        >
          Accept Invite
        </Button>
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};
